import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, StringField, BooleanField, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class ShadertoyBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new ShadertoyBox({
            uuid,
            graph,
            name: "ShadertoyBox",
            pointerRules: {
                accepts: [Pointers.Shadertoy],
                mandatory: true,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "ShadertoyBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({});
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitShadertoyBox, this);
    }
    get tags() {
        return ShadertoyBox.Tags;
    }
    get shaderCode() {
        return this.getField(1);
    }
    get highres() {
        return this.getField(2);
    }
    initializeFields() {
        return {
            1: StringField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "shaderCode",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            2: BooleanField.create({
                parent: this,
                fieldKey: 2,
                fieldName: "highres",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
        };
    }
}
